import { motion } from "framer-motion";

import { Icon } from "@/atoms/icon/Icon";
import Cake from "@/atoms/icon/icons/ic_birthday_large_ol.svg";
import Offers from "@/atoms/icon/icons/ic_offers_large_ol.svg";
import Reward from "@/atoms/icon/icons/ic_rewards_large_ol.svg";
import Star from "@/atoms/icon/icons/ic_star_large_ol.svg";

export interface SignUpPerksProps {
  rewardsEnabled?: boolean;
  spendBasedRewardsEnabled?: boolean;
  className?: string;
  animate?: boolean;
}

export const SignUpPerks = ({
  rewardsEnabled = true,
  spendBasedRewardsEnabled = true,
  className = "",
  animate = false,
}: SignUpPerksProps) => {
  const perks = [
    {
      icon: Star,
      text: "Free reward for new members!",
      show: rewardsEnabled,
    },
    {
      icon: Reward,
      text: spendBasedRewardsEnabled
        ? "Earn rewards for visits & purchases"
        : "Earn rewards for visits",
      show: rewardsEnabled,
    },
    {
      icon: Cake,
      text: "Free birthday gifts",
      show: true,
    },
    {
      icon: Offers,
      text: "Member only offers & events",
      show: true,
    },
  ];

  const visiblePerks = perks.filter((perk) => perk.show);

  return (
    <div className={`flex flex-col gap-6 px-3 pb-6 pt-0 ${className}`}>
      {visiblePerks.map((perk, index) => (
        <motion.div
          key={index}
          initial={animate ? { opacity: 0, y: 20 } : false}
          animate={animate ? { opacity: 1, y: 0 } : false}
          transition={
            animate
              ? {
                  duration: 0.6,
                  delay: index * 0.25,
                  ease: "easeOut",
                }
              : undefined
          }
          className="flex items-center gap-[13px]"
        >
          <div className="size-8 shrink-0">
            <Icon svg={perk.icon} size={"medium"} color={"brandColor"} />
          </div>
          <div className="font-sans text-[16px] font-normal leading-[22px] text-primary">
            {perk.text}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default SignUpPerks;
